export const CookiesConsent = {
    init: () => {
        const categories = {
            necessary: {
                enabled: true,
                readOnly: true,
            }
        };

        categories.analytics = {
            autoClear: {
                cookies: [
                    { name: /^_ga/ },
                    { name: '_gid' },
                ],
            },
            enabled: true,
        };

        if (typeof window.CookieConsent !== "undefined") {
            window.CookieConsent.run({
                cookie: {
                    expiresAfterDays: 30,
                },
                categories: categories,
                language: {
                    default: "umbraco",
                    translations: JSON.parse(
                        document.getElementById('cc_translations')?.textContent || '{}'
                    ),
                },
                onFirstConsent: () => CookiesConsent.updateGTMConsent(),
                onConsent: () => CookiesConsent.updateGTMConsent(),
                onChange: ({ changedCategories }) => {
                    if (changedCategories.indexOf('analytics') !== -1) {
                        CookiesConsent.updateGTMConsent();
                    }
                },
            });
        }
    },

    updateGTMConsent: () => {
        if (typeof window.CookieConsent !== "undefined" && typeof window.gtag === "function") {
            window.gtag('consent', 'update', {
                analytics_storage: window.CookieConsent.acceptedCategory('analytics')
                    ? 'granted'
                    : 'denied',
            });
        }
    }
};


/*import {getCookie, setCookie} from "../helpers/cookiesHelper";

export const CookiesConsent = {
    cookieName: "accepted_cookies",
    expirationDays: 30,

    init: () => {
        let acceptedCookies = getCookie(CookiesConsent.cookieName);
        // If the cookie is not set, show the modal
        if(acceptedCookies === undefined){
            const btnAccept = document.querySelector("#cookiesConsentModal .js-btn-accept");
            const btnRefuse = document.querySelector("#cookiesConsentModal .js-btn-refuse");
            
            btnAccept.addEventListener("click", CookiesConsent.acceptCookies);
            btnRefuse.addEventListener("click", CookiesConsent.refuseCookies);

            const bsModal = new bootstrap.Modal('#cookiesConsentModal', {});
            bsModal.show();
        }
    },
    acceptCookies: () => {
        setCookie(CookiesConsent.cookieName, true, CookiesConsent.expirationDays);
        
        // Load all marketing / analytics tools
        const modalEl = document.querySelector('#cookiesConsentModal');
        CookiesConsent.loadGTMLib(modalEl.dataset.ga4Id);
    },
    refuseCookies: () => {
        setCookie(CookiesConsent.cookieName, false, CookiesConsent.expirationDays);
    },
    loadGTMLib: (id) => {
        if (id != null && id !== "") {
            const script = document.createElement("script");
            script.src = `https://www.googletagmanager.com/gtag/js?id=${id}`;
            script.async = true;

            //append script
            document.head.appendChild(script);

            //add the other things
            window.dataLayer = window.dataLayer || [];

            function gtag() {
                dataLayer.push(arguments);
            }

            gtag("js", new Date());

            gtag("config", id);
        }
    }
}*/